import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ProposalProvider } from "./context/ProposalContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { RatesProvider } from "./context/RatesContext";
import ProposalWizard from "./pages/ProposalWizard";
import AdminPage from "./pages/AdminPage";
import ClientPage from "./pages/ClientPage";
import AdminLogin from "./pages/AdminLogin";
import AdminVerify from "./pages/AdminVerify";
import SharedProposalPage from "./pages/SharedProposalPage";
import { Toaster } from "./components/ui/sonner";
import { Loader2 } from "lucide-react";

function RequireAuth({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 text-primary animate-spin" />
      </div>
    );
  }
  if (!user) return <AdminLogin />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RatesProvider>
            <Routes>
              <Route
                path="/"
                element={
                  <ProposalProvider>
                    <ProposalWizard />
                  </ProposalProvider>
                }
              />
              <Route path="/p/:token" element={<SharedProposalPage />} />
              <Route path="/admin" element={<RequireAuth><AdminPage /></RequireAuth>} />
              <Route path="/admin/client/:email" element={<RequireAuth><ClientPage /></RequireAuth>} />
              <Route path="/admin/verify" element={<AdminVerify />} />
            </Routes>
          </RatesProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
